import React from "react";
import { useFormik } from "formik";
import { weeks } from "../../../../utils/constanst.js";
import { readBranches } from "../../../../services/branch.service.ts";
import { useState, useEffect } from "react";

interface ConfigHorarioSemanalFiltersProps {
  formik: any;
  branchId: number;
  initialBranchId: number;
  onBranchChange: (branchId: number) => void;
  canChangeBranch: boolean;
  onFilterChange: () => void;
  branchName?: string;
  onExportClick: () => void;
  onSaveClick: () => void;
  onFillWeekClick: () => void;
  onSyncWithScheduleClick: () => void;
  saving?: boolean;
  hasUnsavedChanges?: boolean;
  onRefreshClick: () => void;
  onNotesClick?: () => void;
  onDownloadTablePdf?: () => void;
  exportingTablePdf?: boolean;
}

const ConfigHorarioSemanalFilters: React.FC<ConfigHorarioSemanalFiltersProps> = ({
  formik,
  branchId,
  initialBranchId,
  onBranchChange,
  canChangeBranch,
  onFilterChange,
  branchName,
  onExportClick,
  onSaveClick,
  onFillWeekClick,
  onSyncWithScheduleClick,
  saving = false,
  hasUnsavedChanges = false,
  onRefreshClick,
  onNotesClick,
  onDownloadTablePdf,
  exportingTablePdf = false,
}) => {
  const [branches, setBranches] = useState<any[]>([]);
  const [loadingBranches, setLoadingBranches] = useState(false);

  useEffect(() => {
    if (canChangeBranch) {
      const fetchBranches = async () => {
        try {
          setLoadingBranches(true);
          const branchesData = await readBranches();
          setBranches(branchesData);
        } catch (error) {
          console.error("Error loading branches:", error);
        } finally {
          setLoadingBranches(false);
        }
      };
      fetchBranches();
    }
  }, [canChangeBranch]);

  const inputBase = {
    padding: "10px 14px",
    fontSize: "15px",
    color: "#111827",
    fontWeight: "500" as const,
    backgroundColor: "#F9FAFB",
    border: "1px solid #D1D5DB",
    borderRadius: "8px",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s, background-color 0.2s",
    minHeight: "42px",
  };
  const inputFocus = { borderColor: "#3B82F6", boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.2)", backgroundColor: "#fff" };
  const inputBlur = { borderColor: "#D1D5DB", boxShadow: "none", backgroundColor: "#F9FAFB" };
  const labelStyle = {
    display: "block",
    fontSize: "12px",
    fontWeight: "700",
    color: "#374151",
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
  };

  return (
    <div style={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "20px 24px",
      margin: "16px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      border: "1px solid #E5E7EB",
    }}>
      <div style={{
        display: "flex",
        alignItems: "flex-end",
        gap: "20px",
        flexWrap: "wrap",
      }}>
        <div style={{ minWidth: "200px", flex: "1 1 200px", maxWidth: "280px" }}>
          <label style={labelStyle}>Sucursal</label>
          {canChangeBranch ? (
            <select
              value={branchId}
              onChange={(e) => onBranchChange(Number(e.target.value))}
              style={{ ...inputBase, width: "100%", cursor: "pointer" }}
              onFocus={(e) => Object.assign(e.target.style, inputFocus)}
              onBlur={(e) => Object.assign(e.target.style, inputBlur)}
              disabled={loadingBranches}
            >
              {loadingBranches ? (
                <option value={branchId}>Cargando...</option>
              ) : (
                branches.map((b) => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))
              )}
            </select>
          ) : (
            <div style={{ ...inputBase, width: "100%", backgroundColor: "#F3F4F6", cursor: "default", color: "#111827", fontWeight: "600" }}>
              {branchName || "Cargando..."}
            </div>
          )}
        </div>

        <div style={{ minWidth: "200px", flex: "1 1 200px", maxWidth: "280px" }}>
          <label style={labelStyle}>Semana</label>
          <select
            value={formik.values.week}
            onChange={(e) => formik.setFieldValue("week", Number(e.target.value))}
            style={{ ...inputBase, width: "100%", cursor: "pointer" }}
            onFocus={(e) => Object.assign(e.target.style, inputFocus)}
            onBlur={(e) => Object.assign(e.target.style, inputBlur)}
          >
            {weeks.map((week: any) => (
              <option key={week.id} value={week.id}>{week.name}</option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "auto", flexShrink: 0 }}>
          {onNotesClick && (
            <button
              type="button"
              onClick={onNotesClick}
              title="Notas de la semana"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 14px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#854D0E",
                backgroundColor: "#FEF9C3",
                border: "1px solid #FDE047",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FEF08A";
                e.currentTarget.style.borderColor = "#FACC15";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FEF9C3";
                e.currentTarget.style.borderColor = "#FDE047";
              }}
            >
              <i className="fas fa-sticky-note" style={{ fontSize: "14px" }} />
              <span>Notas de la semana</span>
            </button>
          )}
          <button
            type="button"
            onClick={onRefreshClick}
            title="Refrescar datos"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "10px 14px",
              minHeight: "42px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#065F46",
              backgroundColor: "#D1FAE5",
              border: "1px solid #6EE7B7",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#A7F3D0";
              e.currentTarget.style.borderColor = "#34D399";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#D1FAE5";
              e.currentTarget.style.borderColor = "#6EE7B7";
            }}
          >
            <i className="fas fa-rotate-right" style={{ fontSize: "14px" }} />
            <span>Actualizar</span>
          </button>
          {onDownloadTablePdf && (
            <button
              type="button"
              onClick={onDownloadTablePdf}
              disabled={exportingTablePdf}
              title="Descargar la tabla actual como PDF"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 14px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#FFFFFF",
                backgroundColor: exportingTablePdf ? "#9CA3AF" : "#DC2626",
                border: `1px solid ${exportingTablePdf ? "#6B7280" : "#B91C1C"}`,
                borderRadius: "8px",
                cursor: exportingTablePdf ? "not-allowed" : "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!exportingTablePdf) {
                  e.currentTarget.style.backgroundColor = "#B91C1C";
                  e.currentTarget.style.borderColor = "#991B1B";
                }
              }}
              onMouseLeave={(e) => {
                if (!exportingTablePdf) {
                  e.currentTarget.style.backgroundColor = "#DC2626";
                  e.currentTarget.style.borderColor = "#B91C1C";
                }
              }}
            >
              <i className={`fas ${exportingTablePdf ? "fa-spinner fa-spin" : "fa-file-pdf"}`} style={{ fontSize: "14px" }} />
              <span>{exportingTablePdf ? "Descargando..." : "Descargar tabla PDF"}</span>
            </button>
          )}
          {hasUnsavedChanges && (
            <button
              type="button"
              onClick={onSaveClick}
              disabled={saving}
              title="Guardar horario semanal"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 20px",
                minHeight: "42px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#1D4ED8",
                backgroundColor: saving ? "#E0E7FF" : "#DBEAFE",
                border: "1px solid #93C5FD",
                borderRadius: "8px",
                cursor: saving ? "not-allowed" : "pointer",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#BFDBFE";
                  e.currentTarget.style.borderColor = "#60A5FA";
                }
              }}
              onMouseLeave={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#DBEAFE";
                  e.currentTarget.style.borderColor = "#93C5FD";
                }
              }}
            >
              {saving ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: "14px" }} />
                  <span>Guardando...</span>
                </>
              ) : (
                <>
                  <i className="fas fa-check" style={{ fontSize: "14px" }} />
                  <span>Guardar</span>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigHorarioSemanalFilters;
